import { Alert, Dialog, FormStack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { ProviderDatabase } from '../../../../types';
import ProviderTagPicker from '../ProviderTagPicker/ProviderTagPicker';
import useAddUpdateProviderForm from './useAddUpdateProviderForm';

type Props = {
  onClose: () => void;
  provider?: ProviderDatabase;
  afterSuccess?: (provider?: ProviderDatabase) => void;
}

export default function AddUpdateProviderModal(props: Props) {
  const hook = useAddUpdateProviderForm({
    provider: props.provider,
    onClose: props.onClose,
    afterSuccess: props.afterSuccess,
  });

  return (
    <Dialog
      open
      onClose={props.onClose}
      onSubmit={hook.onSubmit}
      maxWidth="sm"
      fullWidth
      title={props.provider ? 'Modification du prestataire' : 'Nouveau prestataire'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: props.provider ? 'Modifier' : 'Créer',
          type: 'submit',
          loading: hook.isSubmitting,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: hook.isSubmitting,
        },
      }}
    >
      <FormStack>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          control={hook.form.control}
          name="name"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value ?? ''}
              label="Nom"
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              autoFocus
            />
          )}
        />

        <Controller
          control={hook.form.control}
          name="description"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value ?? ''}
              label="Description"
              placeholder="Ex. : maintenance ascenseur, plomberie…"
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <ProviderTagPicker
          selectedTags={hook.selectedTags}
          onChange={hook.setSelectedTags}
          triggerButtonText="Attribuer des tags"
        />

        <Controller
          control={hook.form.control}
          name="address"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value ?? ''}
              label="Adresse"
              fullWidth
              multiline
              minRows={2}
              autoComplete="street-address"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </FormStack>
    </Dialog>
  );
}
